import React from 'react'
import { connect } from 'react-redux'
import PromotionLink from './PromotionLink'
import NectarPromotionLink from '@/components/NectarPromotionLink/NectarPromotionLink'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

export const PromotionContainer = props => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()

  return PDP_V2_FLAG ? <NectarPromotionLink {...props} /> : <PromotionLink {...props} />
}

export const mapStateToProps = state => {
  const { productStore } = state

  const promotions = productStore.data.promotions ? productStore.data.promotions.attributes.rewards : null

  return {
    promotions
  }
}

export default connect(mapStateToProps)(PromotionContainer)
